const JS_STOP_PROPAGATION = "js-propagation-exception";

export function initialize() {
  document
    .querySelector(".js-stop-propagation")
    .addEventListener("click", (e) => {
      if (checkForExceptionPath(e)) {
        e["preventSidebarClosing"] = true;
      }
    });
}

function checkForExceptionPath(e): boolean {
  // If clicked element have stop propagation class then don't add preventSidebarClosing
  if (e.path) {
    return !e.path[0].classList.contains(JS_STOP_PROPAGATION);
  } else if (e.composedPath) {
    return !(e.composedPath()[0] as Element).classList.contains(
      JS_STOP_PROPAGATION
    );
  }
  return true;
}
